export const parseQuerySearch = (url, query) => {
  if (!url) {
    return null
  }
  const _url = new URL(url)
  const _query = new URLSearchParams(_url.search)
  return _query.get(query)
}
